/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import util from 'meinian-package/src/utils/util'
import logo from 'image/logo_icon.png'
import { ossImg } from 'meinian-package/src/utils/image'
import { useDeepCompareEffect } from 'ahooks'
import { PLATFORM_CONFIG_ENUM } from 'meinian-package/src/component/enum'
import ImageDetail from 'view/detail/imageDetail'
import { Layer } from '../image.base'
import { BatchItem } from '../../../batch'
import { StyleStateLabel } from '../styleInfo'
import styles from './index.module.less'

const Image = (props) => {
  const {
    platformId,
    outerIndex,
    total,
    data = [],
    mainUrl,
    imageGroupEntityId,
    inspirationId,
    isBatch,
    onClickCard,
    columnWidth,
    viewConfig = {}, // 视图设置
    item
  } = props
  const Card = PLATFORM_CONFIG_ENUM.has(platformId) ? Image[PLATFORM_CONFIG_ENUM.get(platformId).component] : null
  const [visible, setVisible] = useState(false)
  const [index, setIndex] = useState(outerIndex)

  const [itemData, setItemData] = useState(item)

  useDeepCompareEffect(() => {
    setItemData(item)
  }, [item])

  useEffect(() => {
    setIndex(outerIndex)
  }, [outerIndex])

  const onChangeIndex = (_outerIndex) => {
    setIndex(_outerIndex)
    props.onChangeIndex && props.onChangeIndex(_outerIndex)
  }

  const _onChange = (success, itemParams) => {
    if (success) {
      setItemData({ ...props.item, ...itemParams })
      props.onResize?.()
    }
  }
  const auth = itemData.loginUserInfo?.inspirationPermissions || []
  return <div className={classNames(styles['meinian-waterfall-card-image-wrap'])} style={{ width: columnWidth, height: columnWidth }}>
    <div
      className="meinian-waterfall-card-image"
      onClick={e => {
        if (window.location.pathname.startsWith('/meinian/home/workbench')) {
          util.track('mn-workbench-click', {
            module1: '款式查看',
            module2: props.trackModule2,
            module3: '款式详情',
          })
        }
        onClickCard ? onClickCard(data[outerIndex], e) : !isBatch && setVisible(true)
      }}
    >
      {
        !isBatch && columnWidth >= 230 && <Layer
          {...props}
          onChange={_onChange}
          itemData={itemData}
          hiddenMark={viewConfig.markInfo}
        >
          {Card && viewConfig.originalInfo && <Card {...props} />}
        </Layer>
    }
      {
        isBatch && <div className="batch-mask">
          <BatchItem keyValue={`${imageGroupEntityId},${inspirationId}`} className="batch-check" info={data[outerIndex]} />
        </div>
    }
      <ImageView
        mainUrl={ossImg(mainUrl, 400)}
        style={{ height: columnWidth }}
        secondImgUrl={ossImg(itemData?.imageUrlList?.[0], 400)}
        firstImgUrl={ossImg(itemData?.imageUrlList?.[1])}
        lastImgUrl={ossImg(itemData?.imageUrlList?.[2])}
      />
      <StyleStateLabel auth={auth} itemData={itemData} viewConfig={viewConfig} />
    </div>
    {visible ? <ImageDetail
      outerIndex={index}
      listLength={total || data.length}
      onChangeIndex={onChangeIndex}
      visible={visible}
      blogId={data?.[index].imageGroupEntityId}
      inspirationId={data?.[index].inspirationId}
      collectId={data?.[index].collectId}
      onChange={_onChange}
      onVisibleChange={(_visible) => { setVisible(_visible); setIndex(outerIndex) }}
      onDeleteItem={props.onDeleteItem}
      initWaterfall={props.initWaterfall}
      initSubColls={props.initSubColls}
    /> : null}
  </div>
}

export default Image

const ImageView = ({ mainUrl, secondImgUrl, firstImgUrl, lastImgUrl, style }) => {
  return <div className={styles['multi-image-view']} style={style}>
    <div className="main-img">
      <img style={{ objectFit: 'cover' }} src={mainUrl || logo} />
    </div>
    <div className="recent-update-img">
      <div className="recent-img-1">
        {firstImgUrl ? <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={firstImgUrl} /> : <img style={{ width: '34%' }} src={logo} />}
      </div>
      <div className="recent-img-2">
        {secondImgUrl ? <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={secondImgUrl} /> : <img style={{ width: '34%' }} src={logo} />}
      </div>
      <div className="recent-img-3">
        {lastImgUrl ? <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={lastImgUrl} /> : <img style={{ width: '34%' }} src={logo} />}
      </div>
    </div>
  </div>
}
